import React from 'react';
import { Label } from '@/components/ui/label';
import { StyleBadge } from '@/components/ui/StyleBadge';

// ============================================================================
// FieldShell — ЕДИНАЯ обёртка поля формы (SRP/DRY): подпись (с условным
// оформлением-стилем), звёздочка обязательности, ошибка под полем.
// Дублировалась ~8 раз в renderField/ветках — вынесена в один компонент.
// ============================================================================

interface FieldShellProps {
  label: string;
  /** стиль условного оформления (StyleBadge), если задан */
  labelStyle?: any;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
}

export function FieldShell({ label, labelStyle, error, required, children }: FieldShellProps) {
  const labelNode = labelStyle ? <StyleBadge text={label} attrs={labelStyle} /> : <span>{label}</span>;
  return (
    <div className="space-y-1">
      <Label className={`text-xs ${error ? 'text-destructive' : ''}`}>
        {labelNode}
        {required ? <span className="text-destructive ml-0.5">*</span> : null}
      </Label>
      {children}
      {error && <div className="text-[10px] text-destructive">{error}</div>}
    </div>
  );
}
